module.exports = __webpack_public_path__ + "static/media/ill_borrelia.cbc4afbf.svg";